<script setup>
import { computed } from 'vue';

const { columns, gap } = defineProps(['columns', 'gap']);

const styles = computed(() => {
    return {
        '--columns': columns,
        '--gap': `${gap}px`
    }
});

</script>

<template>
    <div class="grid" :style="styles">
        <slot />
    </div>
</template>

<style scoped>
.grid {
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    gap: var(--gap);
}
</style>